import { RepositoryTab } from '@/features/Transition360/Repository/RepositoryTab';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const repositorySearchSchema = z.object({
    tags: z.array(z.string().min(1)).optional().catch(undefined),
});

export const Route = createFileRoute(
    '/transition-360/projects/$projectId/assets/$projectAssetId/repository',
)({
    validateSearch: repositorySearchSchema,
    component: RepositoryTabRoute,
});

function RepositoryTabRoute() {
    const { projectId, projectAssetId } = Route.useParams();
    const { tags } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
        <RepositoryTab
            projectId={projectId}
            projectAssetId={projectAssetId}
            tagFilter={tags ?? []}
            onTagFilterChange={(next) =>
                navigate({
                    search: (previous) => ({
                        ...previous,
                        tags: next.length ? [...new Set(next)] : undefined,
                    }),
                })
            }
        />
    );
}
